import alertify from '@/libs/alertify';
// import { getSign, setSign } from 'logicDir/auth';
import { readCache, writeCache } from '@/libs/cache';
// import bus from 'eventBus';
import config from '@/config/common.config';
import Fly from 'flyio/dist/npm/fly';

/* API统一回复的字段名字典 */
const API_FIELD = {
  RESULT_CODE: 'code',
  MESSAGE: 'msg',
  DATA: 'data',
};
/* 每次请求都会带上的字段 */
// const REQUEST_COMMON_FIELD = {
//   SIGN: 'token',
//   EXPIRED_TIME: 'token_expired_time',
// };
/* API结果里的CODE的含义以及对应的状态码 */
const API_CODE = {
  SUCCESS_VALUE: 1001,
  SIGN_OUTDATE_VALUE: 1002,
  NORMAL_ERROR_VALUE: 1003,
  SPECIAL_ERROR_VALUE: 1007,
};
/* 本模块的默认配置 */
const defaultAjaxSetting = {
  // withSign: false, // 默认需要提供登录凭证
};

/* fly实例化并进行全局配置 */
const fly = new Fly();
fly.config.timeout = 5000;
fly.config.baseURL = config.API_ROOT;

/* 拦截器 */
fly.interceptors.response.use(
  (response) => {
    return pf._successHandle(response.data);
  },
  (error) => {
    // 对响应错误做点什么
    pf._ajaxErrorHandle();
    return Promise.reject(error);
  }
);

// export function ajaxUrlHandle(originalUrl) {
//   let finalUrl = originalUrl;
//   if (!!originalUrl && originalUrl.indexOf('http://') !== 0) {
//     finalUrl = config.API_ROOT + originalUrl;
//   }
//   return finalUrl;
// }

/* 请求默认带上某些参数，比如说sign */
// export function attachAjaxSystemData(ajaxData) {
//   const sign = getSign();
//   ajaxData[REQUEST_COMMON_FIELD.SIGN] = sign[REQUEST_COMMON_FIELD.SIGN];
//   ajaxData[REQUEST_COMMON_FIELD.EXPIRED_TIME] = sign[REQUEST_COMMON_FIELD.EXPIRED_TIME];
// }
/* 将sign拼成url query参数的形式 */
// export function getSignParamsUrlStr() {
//   const sign = getSign();
//   const paramsArr = [];
//   for (const key in REQUEST_COMMON_FIELD) {
//     if (REQUEST_COMMON_FIELD.hasOwnProperty(key)) {
//       const _field = REQUEST_COMMON_FIELD[key];
//       paramsArr.push(`${_field}=${sign[_field]}`);
//     }
//   }
//   return paramsArr.join('&');
// }

const pf = {
  /* 每次发送请求前都针对传入的参数进行一些处理 */
  _prepareCustomSetting(setting) {
    // setting.url = ajaxUrlHandle(setting.url);

    if (!setting.params) {
      setting.params = {};
    }

    // if (setting.withSign) { // 如果该API需要附上sign
    //   attachAjaxSystemData(setting.params); // 给参数附上sign
    // }

    return setting;
  },
  /* 对于sign过期的处理 */
  // _signOudatedHandle(jsonData) {
  //   /* 静默登录 */
  //   bus.$emit('sign-outdated');
  // },
  /* 对于服务器成功回复的处理 */
  _ajaxSuccessHandle(jsonData) {
    if (!!jsonData[API_FIELD.MESSAGE]) {
      alertify.success(jsonData[API_FIELD.MESSAGE]);
    }
  },
  /* 对于ajax请求失败回复的处理 */
  _ajaxErrorHandle() {
    alertify.error('操作失败，请检查网络，或直接联系我们');
  },
  /* 对于服务器特定错误回复的处理 */
  _specialErrorHandle(msg) {
    alertify.alert(msg);
  },
  /* 对于服务器笼统错误回复的处理 */
  _normalErrorHandle() {
    alertify.error('系统繁忙，请稍后再试');
  },
  /* 对于服务器response的处理 */
  _successHandle(jsonData) {
    /* 无论API的请求结果如何，都要保存/更新token */
    // setSign(jsonData[API_FIELD.DATA]);

    switch (jsonData[API_FIELD.RESULT_CODE]) {
      case API_CODE.SUCCESS_VALUE:
        pf._ajaxSuccessHandle(jsonData);
        return jsonData[API_FIELD.DATA];
      // case API_CODE.SIGN_OUTDATE_VALUE:
      //   pf._signOudatedHandle(jsonData);
      //   return Promise.reject('sign过期');
      case API_CODE.SPECIAL_ERROR_VALUE:
        pf._specialErrorHandle(jsonData[API_FIELD.MESSAGE]);
        return Promise.reject(jsonData[API_FIELD.MESSAGE]);
      case API_CODE.NORMAL_ERROR_VALUE:
        pf._normalErrorHandle();
        return Promise.reject('系统错误');
      default:
        return Promise.reject({ data: jsonData[API_FIELD.DATA], msg: jsonData[API_FIELD.MESSAGE] });
    }
  },

  /* 针对ajax请求进行cache的处理 */
  _returnCacheHandle(ajaxSetting) {
    return (data) => {
      if (process.env.NODE_ENV !== 'production') { // 除生产环境外，不开启缓存
        return data;
      }
      if (!ajaxSetting.cache) {
        return data;
      }
      const cacheName = this._buildCacheName(ajaxSetting);
      writeCache(cacheName, data);

      return data;
    };
  },

  /* 生成ajax请求的cache的键名 */
  _buildCacheName(ajaxSetting) {
    const cacheSetting = ajaxSetting.cache;
    if (!!cacheSetting.name) {
      return cacheSetting.name;
    }

    if (!!ajaxSetting.params) {
      const paramsArr = [];

      for (const key in ajaxSetting.params) {
        if (ajaxSetting.params.hasOwnProperty(key)) {
          const element = ajaxSetting.params[key];
          paramsArr.push(`${key}=${element}`);
        }
      }

      return ajaxSetting.url + '?' + paramsArr.join('&');
    } else {
      return ajaxSetting.url;
    }

  },

  _ajax(customAjaxSetting, method = 'get') {
    let ajaxSetting = Object.assign({
      method,
    }, defaultAjaxSetting, customAjaxSetting);
    ajaxSetting = pf._prepareCustomSetting(ajaxSetting); // 针对传入的参数进行预处理

    /* 缓存相关 */
    if (!!ajaxSetting.cache) {
      const cacheName = this._buildCacheName(ajaxSetting);
      const cache = readCache(cacheName);
      if (!!cache) {
        return Promise.resolve(cache);
      }
    }

    return fly.request(ajaxSetting.url, ajaxSetting.params, {
      method: ajaxSetting.method,
    }).then(this._returnCacheHandle(ajaxSetting));
  },
};

export default {
  // prepareRequestParams(url) {
  //   const sign = getSign();
  //   url += `&${REQUEST_COMMON_FIELD.SIGN}=` + encodeURIComponent(sign[REQUEST_COMMON_FIELD.SIGN]) + `&${REQUEST_COMMON_FIELD.EXPIRED_TIME}=` + sign[REQUEST_COMMON_FIELD.EXPIRED_TIME];
  //   return url;
  // },

  get(customAjaxSetting) {
    return pf._ajax(customAjaxSetting, 'get');
  },

  post(customAjaxSetting) {
    return pf._ajax(customAjaxSetting, 'post');
  },

  put(customAjaxSetting) {
    return pf._ajax(customAjaxSetting, 'put');
  },
};



// WEBPACK FOOTER //
// ./src/logic/ajax-model.js